<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card tile :loading="isLoading">
      <dialog-toolbar
        :document="document"
        @closeDialog="dialog = false"
      />
      <v-card-text class="mt-6 subtitle-1">
        Вы уверены, что хотите отгрузить документ?
      </v-card-text>

      <v-card-actions class="justify-space-around">

        <v-btn
          large
          fab
          color="error"
          @click="dialog = false"
        >
          <v-icon large>mdi-cancel</v-icon>
        </v-btn>
        <v-btn
          large
          fab
          color="success"
          @click="shipDocument"
        >
          <v-icon large>mdi-check-bold</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dialogToolbar from 'app/document/components/dialogToolbar'
export default {
  name: 'shipConfirmationModal',
  components: {
    dialogToolbar
  },
  data () {
    return {
      dialog: false,
      document: {},
      isLoading: false
    }
  },
  methods: {
    open (document) {
      this.document = document
      this.dialog = true
    },
    shipDocument () {
      this.$emit('setProcess', this.document, 5)
      this.dialog = false
    }
  }
}
</script>

<style scoped>

</style>
